import React from "react";

const World = () => {
  return (
    <div className="world">
      <div id="sky">
        <div className="stars" />
        <div className="black" />
        <div className="clouds" />
      </div>
    </div>
  );
};

export default World;
